'use client'

import { ReactNode } from 'react'
import { useMockupScale } from '../../lib/hooks/useMockupScale'
import '../../sass/landing/MockupFrame.scss'

interface MockupFrameProps {
  children: ReactNode
  className?: string
}

const MockupFrame = ({ children, className }: MockupFrameProps) => {
  const { wrapperRef, innerRef, innerStyle, wrapperStyle, ready } = useMockupScale()

  return (
    <div
      ref={wrapperRef}
      className={`mockup-frame${ready ? ' mockup-frame--ready' : ''}${className ? ` ${className}` : ''}`}
      style={wrapperStyle}
    >
      <div ref={innerRef} className='mockup-frame__inner' style={innerStyle}>
        {children}
      </div>
    </div>
  )
}

export default MockupFrame
